<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="fabricCode"
      resizable
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :height="tableHeight"
      :cell-class-name="cellClassName"
    >
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic-square.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic-square.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic-square.jpg"
              style="width:60px; height:60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:displayName="{ row }">
        <span>{{ row.fabricName }}</span>
        <br />
        <span>{{ row.fabricNameEn }}</span>
        <br />
        <span>NO:</span><span>{{ row.fabricNo }}</span>
      </template>
      <template v-slot:fabricPosition="{ row, rowIndex }">
        <dict-select
          clearable
          filterable
          size="mini"
          v-model="row.fabricPositionCode"
          :selectedLabel.sync="row.fabricPositionName"
          :body="{ dictType: 'fabricPosition' }"
          url="/master/common/dict/biz"
          @change="handleFabricPositionChange(row, rowIndex)"
        ></dict-select>
      </template>
      <template v-slot:widUnit="{ row }">
        <span>{{ $l('form_label_width') || '门幅' }}：</span
        ><span>{{ row.wid }} {{ row.v_widUnit }}</span>
        <br />
        <span>{{ $l('form_label_weight') || '克重' }}：</span
        ><span>{{ row.fabricWeight }} {{ row.v_fabricWeightUnit }}</span>
      </template>
      <template v-slot:fabricContent="{ row }">
        <span>{{ row.fabricContent }}</span>
        <br />
        <span>{{ row.fabricContentEn }}</span>
      </template>
      <template v-slot:opt="{ rowIndex }">
        <div
          style="text-align: center;cursor: pointer;display: flex;align-items: center;justify-content: center;"
          @click="removeFabric(rowIndex)"
        >
          <i
            class="el-icon-delete"
            style="font-size: 19px; margin-right: 7px;color: #fa5c7c;"
          />
          <span style="color: #fa5c7c;">{{ $l('btn_delete') || '删除' }}</span>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    tableHeight: { type: Number, default: 300 },
  },
  data() {
    return {
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    cellClassName({ column }) {
      return column.property === 'col-opt' ? '' : 'align-top'
    },
    handleFabricPositionChange(row, rowIndex) {
      this.$emit('fabric-position-change', { row, rowIndex })
    },
    removeFabric(rowIndex) {
      this.$emit('remove-fabric', rowIndex)
    },
  },
}
</script>

